import { Box, Button, styled } from "@mui/material";
import { Colors } from "../theme";

export const ExamCreationContainer = styled(Box)({
  padding: "10px",
  "& .exam-creation-container": {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "5px",

    padding: "30px",
    backgroundcolor: Colors.text,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    position: "relative",
    overflowY: "auto",
    "@media (max-width: 700px)": {
      padding: "10px",
    },
  },
  "& .span_lable": {
    fontSize: "12px",
  },
  "& input": {
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  },
  "& textarea": {
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    marginBottom: "16px",
    fontFamily: "inherit",
    resize: "vertical",
    minHeight: "50px",
  },
  "& .quiz-header": {
    marginBottom: "24px",
    fontWeight: 500,
  },

  "& .form-grid": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr ",
    gap: "10px",
    marginBottom: "10px",
    "@media (max-width: 700px)": {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
  },

  "& .form-grid-full": {
    gridColumn: "span 3",
  },

  "& .questions-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    flexWrap: "wrap",
    gap: "10px",
    "& h4": {
      fontWeight: 500,
    },
    "& .option-flex": {
      display: "flex",
      gap: "10px",
    },
  },

  "& .question-count": {
    marginLeft: "8px",
    fontSize: "14px",
  },

  "& .question-paper": {
    marginBottom: "15px",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },

  "& .question-header": {
    display: "flex",
    alignItems: "center",
    width: "100%",
    borderRadius: "4px 4px 0 0",
  },

  "& .question-title": {
    fontWeight: "500",
    marginLeft: "8px",
    flexGrow: "1",
  },

  "& .question-content": {
    padding: "16px",
    "@media (max-width: 700px)": {
      padding: "0",
    },
  },

  "& .question-text": {
    maxWidth: "400px",
    "@media (max-width: 768px)": {
      maxWidth: "100%",
    },
  },

  "& .options-title": {
    marginBottom: "16px",
    fontWeight: "500",
  },

  "& .option-item": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    marginBottom: "16px",
    "& .deleteIcon": {
      marginLeft: "10px",
    },
  },

  "& .add-option-btn": {
    marginTop: "8px",
    color: Colors.primary,
  },

  "& .footer-actions": {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "16px",
  },

  "& .cancel-btn": {
    borderColor: "#999",
    color: "#666",
  },

  "& .save-btn": {
    backgroundColor: Colors.primary,
    color: "white",
    "&:hover": {
      backgroundColor: "#e03e00",
    },
  },

  "& .primary-color": {
    color: Colors.primary,
  },

  "& .primary-radio": {
    color: Colors.primary,
    "&.Mui-checked": {
      color: Colors.primary,
    },
  },

  "& .primary-border": {
    borderColor: Colors.primary,
    color: Colors.primary,
  },

  "& .primary-switch .MuiSwitch-switchBase.Mui-checked": {
    color: Colors.primary,
    "& + .MuiSwitch-track": {
      backgroundColor: Colors.primary,
    },
  },
});

export const StyledButton = styled(Button)({
  backgroundColor: "#f5f5f5",
  color: "#111",
  textTransform: "none",
  padding: "8px 15px",
  display: "flex",
  alignItems: "center",
  gap: "5px",
  border: "1px solid #e0e0e0",
  boxShadow: "none",
  width: "fit-content",
  "&:hover": {
    backgroundColor: "#e0e0e0",
    boxShadow: "none",
  },
  "&:disabled": {
    "& svg": {
      opacity: "0.5",
    },
  },
  "& .close-btn": {
    color: "#cc0001",
  },
  "&.submodule-btn": {
    "& svg": {
      color: "#cc0001",
    },
  },

  "&.upload-btn": {
    "& svg": {
      color: "#4caf50",
    },
  },
});

export const modalStyle = {
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  position: "fixed",
  right: "0",
  top: "0",
  bottom: "0",
  width: "100%",
  height: "100vh",
  overflow: "auto",
  border: "none",
  outline: 0,
  zIndex: 999,
  "& .container": {
    width: "600px",
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "10px",
    outline: 0,
    "& .header": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
      "& .hearder-title": {
        fontSize: "18px",
      },
    },
    "@media (max-width: 700px)": {
      width: "400px",
    },
  },
};

export const ModalContain = styled(Box)(() => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  position: "fixed",
  right: "0",
  top: "0",
  bottom: "0",
  width: "100%",
  height: "100vh",
  zIndex: 1011,
}));

export const ActionModal = styled(Box)(() => ({
  position: "fixed",
  zIndex: 1000,
  width: "300px",
  height: "250px",
  backgroundcolor: Colors.text,
  borderRadius: "10px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "25px",
  "& .IconContain": {
    textAlign: "center",
    boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    width: "75px",
    height: "75px",
    backgroundcolor: Colors.text,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-45px",
    "& svg": {
      fontSize: "45px",
      color: "red",
    },
  },
  "& .Title": {
    fontSize: "20px",
    textAlign: "center",
  },
  "& p": {
    fontSize: "12px",
    color: "gray",
  },
  "& .ButtonContain": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    letterSpacing: "1px",
    "& button": {
      border: "none",
      width: "100px",
      height: "35px",
      textAlign: "center",
      fontSize: "13px",
      "&.Delete": {
        backgroundColor: "red",
        color: Colors.text,
        // 0000001c
      },
      "&.Cancel": {
        backgroundcolor: Colors.text,
        color: Colors.grayText,
      },
    },
  },
}));

export const ExamCreationListContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  "& .publish-btn": {
    position: "absolute",
    bottom: "10px",
  },
}));
